import { CARD_HEIGHT, CARD_WIDTH, Game } from '@phaser/scenes/Game';
import { CardObject } from '@phaser/objects/Card.object';
import { clamp } from '@phaser/helpers/Math';

export class HealthbarBehavior {
  public healthbar: Phaser.GameObjects.Rectangle;

  public set health(value: number) {
    const parsedValue = value < 0 ? 0 : value;
    this.healthbar.width = clamp(CARD_WIDTH * (parsedValue / this._maxValue), 0, CARD_WIDTH);
  }

  public set max(value: number) {
    this._maxValue = value < 0 ? 0 : value;
  }

  private _background: Phaser.GameObjects.Rectangle;
  private _scene: Game = Game.current;
  private _maxValue: number = 100;

  constructor(private _card: CardObject) {
    this._maxValue = this._card.data.core.hp;
    this._setHealthbar();
  }

  private _setHealthbar() {
    this._background = this._scene.add.rectangle(0, CARD_HEIGHT / 2 - 5, CARD_WIDTH, 10, 0x000000);
    this.healthbar = this._scene.add.rectangle(0, CARD_HEIGHT / 2 - 5, CARD_WIDTH, 10, 0xFF0000);
    this._card.container.add([this._background, this.healthbar]);
  }
}